import { memo, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { encryptPassword } from "../../helpers/formatter";
import { encryptionKey } from "../../constants/appConstant";
import { RegisterUser, createUserForLbp } from "../../services/userService";
import "../../styles/pages/_register.scss";

const Registration = () => {
  const [username, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmpassword, setConfirmPassword] = useState("");
  const [loanNumber, setLoanNumber] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showLoanNumber, setShowLoanNumber] = useState(false); // for toggling loan number

  const [passwordMatch, setPasswordMatch] = useState(true);

  const history = useNavigate();

  useEffect(() => {
    setPasswordMatch(password === confirmpassword);
  }, [password, confirmpassword]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!passwordMatch) return;

    try {
      const encryptedPassword = encryptPassword(password, encryptionKey.key);
      const payload = {
        user_name: username,
        password: encryptedPassword,
        email_id: email,
        phone_number: "+917389852746",
      };
      await RegisterUser(payload);
      await createUserForLbp({ username });
      history("/confirmRegistration");
    } catch (error) {
      console.error(error);
    }
  };
  

  return (
    <section className="register-wrapper">
      <div className="register-container">
        <div className="illustration-container">
          <img src="/assets/img/Register_image.svg" alt="Illustration" className="illustration-image" />
        </div>

        <div className="form-section">
          <div className="mb-4">
            <img src="/assets/img/HOMEAID.svg" alt="HomeAid Logo" className="mb-3 logo" />
            <h5 className="heading">Create your account and enter a world of possibilities!</h5>
            <p className="text mb-0">
              Already have an account? <a href="/login" className=" login-text">Log In</a>
            </p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="row mb-3">
              <div className="col-md-6 mb-3">
                <div className="floating-input">
                  <input
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    placeholder="Enter your email"
                  />
                  <label htmlFor="email">E-Mail</label>
                  <img src="/assets/img/Mail_icon.svg" alt="email icon" className="floating-icon" />
                </div>
              </div>

              <div className="col-md-6 mb-3">
                <div className="floating-input">
                  <input
                    type="text"
                    id="username"
                    value={username}
                    onChange={(e) => setUserName(e.target.value)}
                    required
                    placeholder="Enter your UserId "
                  />
                  <label htmlFor="username">User ID</label>
                  <img src="/assets/img/person_icon.svg" alt="user icon" className="floating-icon" />
                </div>
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-md-6 mb-3">
                <div className="floating-input">
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    placeholder="Enter your Password"
                  />
                  <label htmlFor="password">Password</label>
                  <img
                    src={showPassword ? "/assets/img/eye_off_icon.svg" : "/assets/img/eye_icon.svg"}
                    alt="toggle password"
                    className="floating-icon"
                    style={{ cursor: "pointer" }}
                    onClick={() => setShowPassword(!showPassword)}
                  />
                </div>
              </div>

              <div className="col-md-6 mb-3">
                <div className="floating-input">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    id="confirmPassword"
                    value={confirmpassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    className={!passwordMatch ? "is-invalid" : ""}
                    required
                    placeholder="Confirm your Password"
                  />
                  <label htmlFor="confirmPassword">Confirm Password</label>
                  <img
                    src={showConfirmPassword ? "/assets/img/eye_off_icon.svg" : "/assets/img/eye_icon.svg"}
                    alt="toggle confirm password"
                    className="floating-icon"
                    style={{ cursor: "pointer" }}
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  />
                </div>
                {!passwordMatch && (
                  <small className="text-danger">Passwords do not match</small>
                )}
              </div>

              <small className="text-muted px-2">
                Use 8 or more characters with a mix of letters, numbers & symbols
              </small>
            </div>

            <div className="mb-3">
              <div className="floating-input">
                <input
                  type={showLoanNumber ? "text" : "password"}
                  id="loanNumber"
                  value={loanNumber}
                  onChange={(e) => setLoanNumber(e.target.value)}
                  placeholder=" "
                />
                <label htmlFor="loanNumber">Loan Number</label>
                <img
                  src={showLoanNumber ? "/assets/img/eye_close_icon.svg" : "/assets/img/eye_icon.svg"}
                  alt="toggle loan number"
                  className="floating-icon"
                  style={{ cursor: "pointer" }}
                  onClick={() => setShowLoanNumber(!showLoanNumber)}
                />
              </div>
            </div>
            <div className="form-check mb-4">
  <input
    type="checkbox"
    id="rememberMe"
    className="form-check-input"
    name="rememberMe"
  />
  <label htmlFor="rememberMe" className="form-check-label">
    Remember Me
  </label>
</div>






            <button type="submit" className=" btn-p w-100 mb-3">Sign Up</button>

            <div className="text-center text-muted social-text mb-2">------------Or Register with------------</div>
            <div className="d-flex justify-content-center gap-3 social buton">
              <img src="/assets/img/Google_icon.svg" alt="Google" className="google-btn" />
              <img src="/assets/img/Apple_icon.svg" alt="Apple" className="apple-btn" />
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default memo(Registration);
